var _path, _path2;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RemoteWork = function RemoteWork(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fill: "none",
      className: "tw-fill-current",
      opacity: "0.4",
      d: "M5.60156 4H18.4016C19.5016 4 20.4016 4.9 20.4016 6V12.5C20.4016 13.6 19.5016 14.5 18.4016 14.5H5.60156C4.50156 14.5 3.60156 13.6 3.60156 12.5V6C3.60156 4.9 4.50156 4 5.60156 4Z"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fill: "none",
      className: "tw-fill-current",
      d: "M16.2018 20.0008H7.80176V17.6008C7.80176 16.6008 8.60176 15.8008 9.60176 15.8008H14.4018C15.4018 15.8008 16.2018 16.6008 16.2018 17.6008V20.0008Z"
    }))]
  });
};
export default RemoteWork;